interface SectionCTAProps {
  href: string
  label: string
}

export default function SectionCTA({ href, label }: SectionCTAProps) {
  return (
    <div className="text-center mt-10">
      <div className="relative inline-flex">
        <div
          className="absolute inset-0 rounded-full opacity-60"
          style={{
            background:
              'linear-gradient(270deg, rgba(68, 255, 154, 0.60) 0%, rgba(68, 176, 255, 0.60) 23.56%, rgba(139, 68, 255, 0.60) 46.15%, rgba(255, 102, 68, 0.60) 67.31%, rgba(235, 255, 112, 0.60) 86.06%)',
            filter: 'blur(15px)',
          }}
        />
        <a
          href={href}
          className="relative flex h-[48px] px-7 py-[15px] justify-center items-center gap-[10px] rounded-full bg-[#0478FB] text-white text-center text-[18px] font-medium leading-none hover:bg-[#0366d6] transition-colors"
        >
          {label}
        </a>
      </div>
    </div>
  )
}
